import {
  Component,
  input,
  output,
} from '@angular/core'
import { DateOperation } from '../../shared/services/filter/date-range-filter'

@Component({
  selector: 'div[dateOperationPicker]',
  host: {
    '[class.with-range]': 'showRange()',
  },
  styles: `
    :host {
      display: grid;
      grid-template: 
          'lt eq gt' 1.5rem / 1fr 1fr 1fr;
      column-gap: 0;
      row-gap: 0.25rem;

      &.with-range {
        grid-template: 
            'lt eq gt' 1.5rem
            'dr dr dr' 1.5rem / 1fr 1fr 1fr;
      }

      .operation-btn {
        border: 1px solid black;
        border-radius: 0.25rem;

        &.lt {
          grid-area: lt;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
          border-right: none;
        }
        &.eq {
          grid-area: eq;
          border-radius: 0;
        }
        &.gt {
          grid-area: gt;
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
          border-left: none;

        }
        &.dr {
          grid-area: dr;
        }

        &.selected {
          background-color: green;
          border-color: green;
          color: white;
        }
      }
    }
    `,
  template: `
    <button
      class="operation-btn lt"
      [class.selected]="['lt', 'lte'].includes(value()!)"
      (click)="selectOperation('lt')"
    >
      Before
    </button>
    <button
      class="operation-btn eq"
      [class.selected]="['eq', 'lte', 'gte'].includes(value()!)"
      (click)="selectOperation('eq')"
    >
      Equal
    </button>
    <button
      class="operation-btn gt"
      [class.selected]="['gt', 'gte'].includes(value()!)"
      (click)="selectOperation('gt')"
    >
      After
    </button>
    @if(showRange()) {
    <button
      class="operation-btn dr"
      [class.selected]="value() === 'between'"
      (click)="selectOperation('between')"
    >
      Select Range
    </button>
    }
  `,
})
export class DateOperationPickerComponent {
  readonly showRange = input(false)
  readonly value = input.required<DateOperation | null>()

  readonly valueChange = output<DateOperation>()

  public selectOperation(next: DateOperation) {
    const value = this.value()
    if (next !== value) {
      const nextValue = (): DateOperation => {
        if ((next === 'lt' && value === 'eq') || (next === 'eq' && value === 'lt')) {
          // lt + eq -> lte, eq + lt -> lte
          return 'lte'
        } else if ((next === 'gt' && value === 'eq') || (next === 'eq' && value === 'gt')) {
          // gt + eq -> gte, eq + gt -> gte
          return 'gte'
        } else {
          return next
        }
      }
      this.valueChange.emit(nextValue())
    }
  }
}
